import { style } from '@vanilla-extract/css'

export const layoutPortal = style({})

export const layoutPortal_modal = style({})
